import { Col, DatePicker, Form, Radio, Select } from "antd";
import "antd/dist/antd.min.css";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "../../styles/Main.scss";

import ButtonField from "../../common/htmlComponents/ButtonField";
import dayjs from "dayjs";

const RequestedDemoFilterModel = ({
  modalKeyRefreshFilter,
  setStateM,
  modalKeyFilter,
  setStateList,
  filterApplied,
  stateList,
  form,
  setStatusFilter,
  handleCancel,
  setEndDate,
  setStartDate,
  setFilterApplied,

  setRequestedStatus,
  endDate,
  startDate,
  setResetFieldFilter,
  resetFieldFilter,
  requestedStatus,
  setRequestMaxDate,
  setRequestMinDate,
  setDemoMaxDate,
  setDemoMinDate,
  setFlag,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const { Option } = Select;
  const [selectedDate, setSelectedDate] = useState("request_date");

  useEffect(() => {
    const resetForm = () => {
      formRef.current.resetFields();
      setRequestMinDate(null);
      setRequestMaxDate(null);
      setDemoMinDate(null);
      setDemoMaxDate(null);
      setRequestedStatus("");
      setFilterApplied(false);
    };
    resetForm();
  }, [modalKeyFilter, modalKeyRefreshFilter]);
  const handleMinRequestDateChange = (date) => {
    if (date && moment(date).isValid()) {
      const formatted = moment(date).format("DD-MM-YY");
      setRequestMaxDate(formatted);
    } else {
      setRequestMaxDate(null);
    }
  };
  // const handleMaxRequestDateChange = (date) => {
  //   console.log('dateds', date);
    
  //   if (date && moment(date).isValid()) {
  //     // setRequestMinDate(moment(date).format("DD-MM-YYYY"));
  //     dayjs(date, "DD-MM-YYYY HH:mm").format("DD-MM-YY HH:mm")
  //   } else {
  //     setRequestMinDate(null);
  //   }
  //   // setRequestMinDate(moment(date).format("DD-MM-YYYY"));
  // };


  const handleMaxRequestDateChange = (date) => {
    if (date && moment(date).isValid()) {
      const formatted = moment(date).format("DD-MM-YY");
      console.log('formattedxz', formatted);
      
      setRequestMinDate(formatted); 
    } else {
      setRequestMinDate(null);
    }
  };

  const handleMinDemoDateChange = (date) => {
    // setDemoMaxDate(moment(date).format("DD-MM-YYYY"));
    if (date && moment(date).isValid()) {
      const formatted = moment(date).format("DD-MM-YY");
      setDemoMaxDate(formatted);
    } else {
      setDemoMaxDate(null);
    }
  };

  const handleMaxDemoDateChange = (date) => {
    if (date && moment(date).isValid()) {
      const formatted = moment(date).format("DD-MM-YY");
      setDemoMinDate(formatted);
    } else {
      setDemoMinDate(null);
    }

  };

  const handleSelectChange = (value) => {
    setRequestedStatus(value);
  };

  // const backToList = () => {
  //   setRequestMaxDate(null),
  //   setRequestMinDate(null),
  //   setDemoMaxDate(null),
  //   setDemoMinDate(null),
  //   setStatusFilter("");
  //   setStartDate(null);
  //   setEndDate(null);
  //   setRequestedStatus("");
  //   formRef.current.resetFields();
  //   handleCancel();
  // };

  const handleRadioChange = (e) => {
    setSelectedDate(e.target.value);
    if (e.target.value === "request_date") {
      setDemoMinDate(null);
      setDemoMaxDate(null);
      setRequestedStatus("");
      formRef.current.setFieldsValue({
        demo_date__gte: null,
        demo_date__lte: null,
        status: "",
      });
    } else {
      setRequestedStatus("");
      setRequestMinDate(null);
      setRequestMaxDate(null);
      // formRef.current.resetFields();
      formRef.current.setFieldsValue({
        request_date__gte: null,
        request_date__lte: null,
        status: "",
      });
    }
  };
  const handleSubmit = () => {
    // setDemoMinDate(startDate ? moment(startDate).format("DD-MM-YYYY") : null);
    // setDemoMaxDate(endDate ? moment(endDate).format("DD-MM-YYYY") : null);

    // setRequestMinDate(startDate ? moment(startDate).format("DD-MM-YYYY") : null);
    // setRequestMaxDate(endDate ? moment(endDate).format("DD-MM-YYYY") : null);
    setStateM((prev) => ({
      ...prev,
      status: requestedStatus,
      search: "",
      page: 1,
    }));
    form.setFieldsValue({ search: "" });
    // setReload((reload) => !reload);
    setResetFieldFilter(false);
    setFlag((prev) => !prev);
    setStatusFilter(requestedStatus);
    // setFilterClick(true);
    setFilterApplied(true);
    handleCancel();
  };
  const backToList = () => {
    if (filterApplied !== true) {
      formRef.current.resetFields();
      setRequestMinDate(null);
      setRequestMaxDate(null);
      setDemoMinDate(null);
      setDemoMaxDate(null);
      setRequestedStatus("");
      setFilterApplied(false);
      handleCancel();
    } else {
      handleCancel();
    }
  };
  const statusValues = [
    { value: "", label: "None" },
    { value: "Yet to Attend", label: "Yet To Attend" },
    { value: "Approached", label: "Approached" },
    { value: "Proposal Sent", label: "Proposal Sent" },
    { value: "Award of Order", label: "Award Of Order" },
    { value: "To be Discard", label: "To Be Discard" },
  ];

  return (
    <>
      <div>
        <Form
          className="ModalForm"
          autoComplete="off"
          onFinish={handleSubmit}
          ref={formRef}
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Form.Item
              className="radioitem"
              name="selected_date"
              initialValue={"request_date"}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Radio.Group onChange={handleRadioChange} value={selectedDate}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Radio value={"request_date"}>Request Date</Radio>
                  <Radio value={"demo_date"}>Demo Date</Radio>
                </div>
              </Radio.Group>
            </Form.Item>
          </div>

          {selectedDate === "request_date" ? (
            <>
              <div className="ModalPopupFooter">
                <Col md={16} className="TextFeild">
                  <Form.Item name="request_date__lte" label={t("pl_min_date")}>
                    <DatePicker
                      format="DD-MMMM-YYYY"
                      onChange={handleMinRequestDateChange}
                    />
                  </Form.Item>
                </Col>
              </div>
              <div className="ModalPopupFooter">
                <Col md={16} className="TextFeild">
                  <Form.Item name="request_date__gte" label={t("pl_max_date")}>
                    <DatePicker
                      format="DD-MMMM-YYYY"
                      onChange={handleMaxRequestDateChange}
                    />
                  </Form.Item>
                </Col>
              </div>
            </>
          ) : (
            <>
              <div className="ModalPopupFooter">
                <Col md={16} className="TextFeild">
                  <Form.Item name="demo_date__lte" label={t("pl_min_date")}>
                    <DatePicker
                      format="DD-MMMM-YYYY"
                      onChange={handleMinDemoDateChange}
                    />
                  </Form.Item>
                </Col>
              </div>
              <div className="ModalPopupFooter">
                <Col md={16} className="TextFeild">
                  <Form.Item name="demo_date__gte" label={t("pl_max_date")}>
                    <DatePicker
                      format="DD-MMMM-YYYY"
                      onChange={handleMaxDemoDateChange}
                    />
                  </Form.Item>
                </Col>
              </div>
            </>
          )}

          <div className="ModalPopupFooter">
            <Col md={16} className="TextFeild">
              <div className="SelectStatusSec">
                <Form.Item name="status" label={t("pl_status")}>
                  <Select
                    placeholder={t("pl_select_status")}
                    onChange={handleSelectChange}
                  >
                    {statusValues.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="ModalPopupFooter">
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  htmlType="button"
                  label={t("cancel")}
                  // onClick={handleCancel}
                  onClick={backToList}
                />
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="submit"
                  label={t("filter")}
                  onClick={handleSubmit}
                />
              </div>
            </Col>
          </div>
        </Form>
      </div>
    </>
  );
};

RequestedDemoFilterModel.propTypes = {
  // setMaxDate: PropTypes.func,
  // setMinDate: PropTypes.func,

  setStateM: PropTypes.func,
  setStatusFilter: PropTypes.func,
  setEndDate: PropTypes.func,
  setStartDate: PropTypes.func,
  setRequestedStatus: PropTypes.func,
  endDate: PropTypes.object,
  startDate: PropTypes.object,
  requestedStatus: PropTypes.string,
  handleCancel: PropTypes.func.isRequired,
  setRequestMaxDate: PropTypes.func,
  setRequestMinDate: PropTypes.func,
  setDemoMaxDate: PropTypes.func,
  setDemoMinDate: PropTypes.func,
  resetFieldFilter: PropTypes.bool,
  setResetFieldFilter: PropTypes.func,
  setFlag: PropTypes.func,
  setStateList: PropTypes.func,
  stateList: PropTypes.object,
  form: PropTypes.object,
  modalKeyFilter: PropTypes.bool,
  modalKeyRefreshFilter: PropTypes.bool.isRequired,
  setFilterApplied: PropTypes.func.isRequired,
  filterApplied: PropTypes.bool.isRequired,
};

export default RequestedDemoFilterModel;
